export default function FabricIntro() {
  return (
    <section className="py-20 bg-white border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Image */}
          <div className="w-full h-96 rounded-xl overflow-hidden">
            <img
              src="/assets/img/7f1197bd95cb.webp"
              alt="Premium 3-ply stretch tent fabric"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Text */}
          <div>
            <p className="text-teal-500 text-sm font-semibold tracking-widest uppercase mb-4">
              Our Fabric
            </p>
            <h2 className="text-4xl font-extrabold text-gray-900 mb-6 leading-snug">
              Patented 3-Ply Technology
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-6">
              Our stretch tents are made from a patented 3-ply fabric, expertly treated with water-repellent, antimicrobial, and Teflon innovations, ensuring unmatched longevity and performance in any weather condition.
            </p>
            <p className="text-gray-500 leading-relaxed">
              Each layer of the fabric serves a distinct purpose. The outer layer provides weather protection, the middle layer delivers structural elasticity, and the inner layer offers antimicrobial and Teflon-treated comfort. Together, they create a product that outlasts, outperforms, and outshines the competition.
            </p>
            <div className="mt-8 flex items-center gap-6">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg">
                  <i className="ri-shield-check-line text-teal-500 text-lg"></i>
                </div>
                <span className="text-sm font-semibold text-gray-700">Certified Quality</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg">
                  <i className="ri-leaf-line text-teal-500 text-lg"></i>
                </div>
                <span className="text-sm font-semibold text-gray-700">Eco-Treated</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-teal-50 rounded-lg">
                  <i className="ri-time-line text-teal-500 text-lg"></i>
                </div>
                <span className="text-sm font-semibold text-gray-700">Long-Lasting</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
